module.exports = __webpack_public_path__ + "static/media/Vectorback.21143dbe.svg";